import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';
import TPGrid from 'components/TP-UI/TPGrid';
import TPButton from 'components/TP-UI/TPButton';
import { REDUX_FORM_DEFAULT_CONFIG } from 'constants/form';
import FormError from 'modules/common/FormError';
import SmsCodeVerificationForm from 'modules/auth/components/SmsCodeVerificationForm';

import useStyles from './styles';
import { SMS_VERIFICATION_TYPE } from 'modules/auth/constants';

const PhoneVerificationForm = ({
  phoneNumber,
  handleSubmit,
  error,
  submitFailed,
  pending,
  onCodeSent,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('auth');
  return (
    <form className={classes.form} onSubmit={handleSubmit} noValidate>
      <TPGrid container spacing={2} direction="column">
        {error && submitFailed && (
          <TPGrid item xs={12}>
            <FormError error={error} />
          </TPGrid>
        )}
        <TPGrid item container spacing={1} direction="column">
          <SmsCodeVerificationForm
            phoneNumber={phoneNumber}
            allowResend
            onCodeSent={onCodeSent}
            type={SMS_VERIFICATION_TYPE.PHONE_NUMBER}
          />
        </TPGrid>
        <TPGrid item xs={12}>
          <TPButton fullWidth primary size="large" type="submit" loading={pending}>
            {t('verifyPhone.verifyCodeForm.button')}
          </TPButton>
        </TPGrid>
      </TPGrid>
    </form>
  );
};

PhoneVerificationForm.propTypes = {
  form: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string,
  pending: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onCodeSent: PropTypes.func,
};

export default reduxForm({ ...REDUX_FORM_DEFAULT_CONFIG })(PhoneVerificationForm);
